import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromPicklists from '../reducers/picklists.reducer';

export const selectPicklistsState = createFeatureSelector<fromPicklists.State>(
  fromPicklists.picklistsFeatureKey
);

export const selectPicklistState = createSelector(
  selectPicklistsState,
  (state: fromPicklists.State) => state.picklist
);

export const selectPicklistsPathState = createSelector(
  selectPicklistsState,
  (state: fromPicklists.State) => state.picklistsPath
);

export const selectPicklistsFilterTypeState = createSelector(
  selectPicklistsState,
  (state: fromPicklists.State) => state.filterType
);

export const selectPicklistsIsLoadingState = createSelector(
  selectPicklistsState,
  (state: fromPicklists.State) => state.isLoading
);

export const selectPicklistsIsMaster = createSelector(
  selectPicklistsState,
  (state: fromPicklists.State) => state.isMasterChecked
);


export const selectPicklistListState = createSelector(
  selectPicklistsState,
  (state: fromPicklists.State) => state.picklists
);

export const selectPicklistsFilterIDState = createSelector(
  selectPicklistsState,
  (state: fromPicklists.State) => state.filterID
);

export const selectPicklistsQueryState = createSelector(
  selectPicklistsState,
  (state: fromPicklists.State) => state.query
);

export const selectPicklistsSelectedState = createSelector(
  selectPicklistsState,
  (state: fromPicklists.State) => state.selected
);

export const selectPicklistsBarcodeState = createSelector(
  selectPicklistsState,
  (state: fromPicklists.State) => state.barcodes
);

export const selectPicklistsDuplicateBarcodeState = createSelector(
  selectPicklistsState,
  (state: fromPicklists.State) => state.duplicateBarcode
);

export const selectPicklistsSortState = createSelector(
  selectPicklistsState,
  (state: fromPicklists.State) => state.sortType
);

export const selectPicklistsDirectionState = createSelector(
  selectPicklistsState,
  (state: fromPicklists.State) => state.direction
);

export const selectPicklistPageState = createSelector(
  selectPicklistsState,
  (state: fromPicklists.State) => {
    state.direction
  }
);
